import { render, staticRenderFns } from "./ResponsiblesForm.vue?vue&type=template&id=25a36795&"
import script from "./ResponsiblesForm.js?vue&type=script&lang=js&"
export * from "./ResponsiblesForm.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports